export const currenciesBySite = {
  ZPAR: {
    ARS: {
      code: 'ARS',
      locale: 'es-AR',
      symbol: '$',
      separator: '.'
    },
    USD: {
      code: 'USD',
      locale: 'es-AR',
      symbol: 'USD',
      separator: '.'
    },
    UYU: {
      code: 'UYU',
      locale: 'es-AR',
      symbol: 'UYU',
      separator: '.'
    }
  },

  IWBR: {
    BRL: {
      code: 'BRL',
      locale: 'pt-BR',
      symbol: 'R$',
      separator: '.'
    }
  },
  WIBR: {
    BRL: {
      code: 'BRL',
      locale: 'pt-BR',
      symbol: 'R$',
      separator: '.'
    }
  },
  CMBR: {
    BRL: {
      code: 'BRL',
      locale: 'pt-BR',
      symbol: 'R$',
      separator: '.'
    }
  },

  ICBR: {
    BRL: {
      code: 'BRL',
      locale: 'pt-BR',
      symbol: 'R$',
      separator: '.'
    }
  },
  '24MX': {
    MXN: {
      code: 'MXN',
      locale: 'es-MX',
      symbol: '$',
      separator: ','
    },
    USD: {
      code: 'USD',
      locale: 'es-MX',
      symbol: 'USD',
      separator: ','
    }
  },
  VAMX: {
    MXN: {
      code: 'MXN',
      locale: 'es-MX',
      symbol: '$',
      separator: ','
    },
    USD: {
      code: 'USD',
      locale: 'es-MX',
      symbol: 'USD',
      separator: ','
    }
  },

  DVPE: {
    PEN: {
      code: 'PEN',
      locale: 'es-PE',
      symbol: 'S/.',
      separator: ','
    },
    USD: {
      code: 'USD',
      locale: 'es-PE',
      symbol: 'USD',
      separator: ','
    }
  },

  UBPE: {
    PEN: {
      code: 'PEN',
      locale: 'es-PE',
      symbol: 'S/.',
      separator: ','
    },
    USD: {
      code: 'USD',
      locale: 'es-PE',
      symbol: 'USD',
      separator: ','
    }
  },

  LLVE: {
    VES: {
      code: 'VES',
      locale: 'es-VE',
      symbol: 'BsS',
      separator: '.'
    },
    USD: {
      code: 'USD',
      locale: 'es-VE',
      symbol: 'USD',
      separator: '.'
    }
  },
  PLEC: {
    ECU: {
      code: 'ECU',
      locale: 'es-EC',
      symbol: 'U$S',
      separator: '.'
    },
    USD: {
      code: 'USD',
      locale: 'es-EC',
      symbol: 'USD',
      separator: '.'
    }
  },
  CAPA: {
    USD: {
      code: 'USD',
      locale: 'es-PA',
      symbol: 'USD',
      separator: ','
    }
  }
};

export const totalCurrencies = {
  ARS: '$',
  USD: 'USD',
  BRL: 'R$',
  MXN: '$',
  PEN: 'S/.',
  VES: 'BsS',
  ECU: 'U$S',
  UYU: 'UYU',
  separators: {
    '24MX': ',',
    VAMX: ',',
    CAPA: ',',
    DVPE: ',',
    IWBR: '.',
    LLVE: '.',
    PLEC: '.',
    UBPE: ',',
    WIBR: '.',
    CMBR: '.',
    ZPAR: '.'
  },
  decimalSeparator: {
    '24MX': '.',
    VAMX: '.',
    CAPA: '.',
    DVPE: '.',
    IWBR: ',',
    LLVE: ',',
    PLEC: ',',
    UBPE: '.',
    WIBR: ',',
    CMBR: ',',
    ZPAR: ','
  }
};

export const currencySymbolByCode = {
  ARS: '$',
  USD: 'USD',
  BRL: 'R$',
  MXN: 'MXN',
  PEN: 'S/.',
  VES: 'BsS',
  ECU: 'U$S',
  UYU: 'UYU'
};

export const getCurrencySymbolByCode = code => {
  return currencySymbolByCode[code] || null;
};

export const currencyOptionsBySite = siteId => {
  const siteConfig = currenciesBySite[siteId];
  return Object.keys(siteConfig).map(k => ({ value: siteConfig[k].code, name: siteConfig[k].symbol }));
};

export const currencyOptionsBySiteClean = siteId => {
  const siteConfig = currenciesBySite[siteId];
  // saco la opcion de USD en Peru
  if (siteConfig.USD && (siteId === 'UBPE' || siteId === 'DVPE')) {
    delete siteConfig.USD;
  }
  if (siteConfig.ECU && siteId === 'PLEC') {
    delete siteConfig.ECU;
  }
  return Object.keys(siteConfig).map(k => ({ value: siteConfig[k].code, name: siteConfig[k].symbol }));
};

export const priceFormatter = (siteId, currency, amount) => {
  const { locale } = currenciesBySite[siteId][currency];
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0
  });
  if (parseInt(amount) > 0) {
    return formatter.format(parseInt(amount));
  }
  return '';
};
